import { BaseAPIModel } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';

class Transaction extends BaseAPIModel {
    static getListUrl({ organizationId, eventId }) {
        if (!organizationId) {
            throw new ArgumentError(`[Model][OrderForm][getAll] organizationId is mandatory`);
        }
        return `/ticket/organizations/${organizationId}/events/${eventId}/transaction`;
    }
}

export default Transaction;
